import type { SearchResultItem } from 'owa-timestream-search-orchestration';
import type CalendarItem from 'owa-service/lib/contract/CalendarItem';
import { userDate, compare, OwaDate, endOfMonth } from 'owa-datetime';
import type { ResultFilterOption } from 'owa-timestream-asset-search';
import { CalendarAssetFilterResultOption } from './filterAssets';

/**
 * Compares two search results
 * @param {SearchResultItem} item1 first result to compare
 * @param {SearchResultItem} item2 second result to compare
 * @returns positive number if item1 > item2, otherwise returns negative number
 */
export default function compareAssets(
    item1: SearchResultItem,
    item2: SearchResultItem,
    selectedResultFilter: ResultFilterOption
): number {
    if (item1.type !== item2.type) {
        // cannot compare items of 2 different types
        return 0;
    }

    // sort by meeting start time
    const parsedDate1 = parseDate(item1, selectedResultFilter);
    const parsedDate2 = parseDate(item2, selectedResultFilter);

    // if showing past events only, reverse the sort order
    return selectedResultFilter?.id === CalendarAssetFilterResultOption.PastEvents
        ? compare(parsedDate2, parsedDate1)
        : compare(parsedDate1, parsedDate2);
}

function parseDate(item: SearchResultItem, selectedResultFilter: ResultFilterOption): OwaDate {
    const calendarItem = item.data as CalendarItem;
    const parsedDate = userDate(calendarItem.Start as string);

    // if showing past events, reverse sort order, so headers need the month date to be at the end
    // of the current month instead of beginning
    if (
        selectedResultFilter?.id === CalendarAssetFilterResultOption.PastEvents &&
        item?.id?.indexOf('monthHeader') >= 0
    ) {
        return endOfMonth(parsedDate);
    }

    return parsedDate;
}
